module.exports = __webpack_public_path__ + "media/images/icons/country_flags/wf-2a313731eae3ed3e6bf36d28026f85ca.svg";